<template>
	<div
		class="g-block-title-tag g-block-title-padding"
		:class="{
			'g-block-title-tag--edit': editable,
			'is-active': editable && active,
			'g-block-title-tag--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-tag__bar" :style="{ background: barBackground }">
			<div class="g-block-title-tag__row">
				<div class="g-block-title-tag__part g-block-title-tag__part--primary">
					<RichTextEditable
						v-if="editable"
						class="g-block-title-tag__text g-block-title-tag__text--primary"
						fit-content
						:model-value="data.primaryText"
						placeholder="中文标题"
						@update:model-value="onPrimaryUpdate"
						@focus="onWrapClick"
					/>
					<div
						v-else
						class="g-block-title-tag__text g-block-title-tag__text--primary"
						v-html="data.primaryText || ''"
					></div>
				</div>

				<span class="g-block-title-tag__slash" :style="{ color: themeColor }"> / </span>

				<div class="g-block-title-tag__part g-block-title-tag__part--secondary" :style="{ color: themeColor }">
					<RichTextEditable
						v-if="editable"
						class="g-block-title-tag__text g-block-title-tag__text--secondary"
						fit-content
						:model-value="data.secondaryText"
						placeholder="标题"
						@update:model-value="onSecondaryUpdate"
						@focus="onWrapClick"
					/>
					<div
						v-else
						class="g-block-title-tag__text g-block-title-tag__text--secondary"
						v-html="data.secondaryText || ''"
					></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { getTitleTagBgGradient, getTitleTagColor } from '../../../templates.js';

	export default {
		name: 'GBlockTitleTag',
		components: { RichTextEditable },
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select', 'update'],
		computed: {
			themeColor() {
				return getTitleTagColor(this.data);
			},
			barBackground() {
				return getTitleTagBgGradient(this.data);
			},
		},
		methods: {
			onWrapClick(e) {
				if (!this.editable) return;
				e?.stopPropagation?.();
				this.$emit('select');
			},
			onPrimaryUpdate(primaryText) {
				this.$emit('update', { primaryText });
			},
			onSecondaryUpdate(secondaryText) {
				this.$emit('update', { secondaryText });
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-title-tag {
		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-title-tag__bar {
		padding: 8px 16px;
	}

	.g-block-title-tag__row {
		display: flex;
		align-items: baseline;
		flex-wrap: wrap;
		gap: 8px;
	}

	.g-block-title-tag__part {
		display: inline-flex;
		align-items: baseline;
		min-width: 0;
	}

	.g-block-title-tag__slash {
		font-size: 14px;
		font-weight: 400;
		line-height: 1.2;
		flex-shrink: 0;
	}

	.g-block-title-tag__text {
		display: inline-flex;
		align-items: baseline;
		line-height: 1.2;
		padding: 0;
		font-family: inherit;
		word-break: break-word;
		white-space: pre-wrap;
		color: inherit;

		&--primary {
			font-size: 16px;
			font-weight: 700;
			color: #333;
		}

		&--secondary {
			font-size: 14px;
			font-weight: 400;
		}

		:deep(.g-rich-text-editable) {
			display: inline-flex;
			align-items: baseline;
			width: auto;
			max-width: 100%;
			color: inherit;
		}

		:deep(.g-rich-text-editable__content) {
			line-height: 1.2;
			min-height: unset;
			height: auto;
			padding: 0;
			color: inherit;
		}

		:deep(span),
		:deep(font),
		:deep(p),
		:deep(div) {
			line-height: inherit;
			margin: 0;
			padding: 0;
			vertical-align: baseline;
			color: inherit;
		}
	}

	.g-block-title-tag--h5 {
		.g-block-title-tag__bar {
			padding: 0.16rem 0.32rem;
		}

		.g-block-title-tag__row {
			gap: 0.16rem;
		}

		.g-block-title-tag__slash {
			font-size: 0.28rem;
		}

		.g-block-title-tag__text--primary {
			font-size: 0.32rem;
		}

		.g-block-title-tag__text--secondary {
			font-size: 0.28rem;
		}
	}
</style>
